function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import lodashIsString from 'lodash/isString';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import * as constants from './constants';
import ChevronDownChunkySvg from '../iconography/icons/ChevronDownChunky';
import ChevronUpChunkySvg from '../iconography/icons/ChevronUpChunky';
var DEFAULT_COLLAPSED_LINK_TEXT = React.createElement("div", null, gettext('Show Details'), React.createElement(Icon, {
  type: React.createElement(ChevronDownChunkySvg, null),
  size: "small"
}));
var DEFAULT_EXPANDED_LINK_TEXT = React.createElement("div", null, gettext('Hide Details'), React.createElement(Icon, {
  type: React.createElement(ChevronUpChunkySvg, null),
  size: "small"
}));
var BASE_CSS_CLASSNAME = 'eds-read-more';

var ReadMore =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ReadMore, _React$PureComponent);

  function ReadMore(props) {
    var _this;

    _classCallCheck(this, ReadMore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReadMore).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleTruncateOnWindowResize", debounce(function () {
      _this.setState({
        shouldTruncateContent: false
      }, function () {
        _this.updateShouldTruncateContent();
      });
    }, 250));

    _defineProperty(_assertThisInitialized(_this), "_setContentDivRef", function (ref) {
      _this.contentDivRef = ref;
    });

    _this.state = {
      isExpanded: props.defaultIsExpanded,
      shouldTruncateContent: false
    };
    return _this;
  }

  _createClass(ReadMore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleTruncateOnWindowResize);
      this.updateShouldTruncateContent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleTruncateOnWindowResize);
    }
  }, {
    key: "updateShouldTruncateContent",
    value: function updateShouldTruncateContent() {
      var collapsedDisplayAmount = this.props.collapsedDisplayAmount;
      var contentDivHeight = this.contentDivRef.offsetHeight;
      this.setState({
        shouldTruncateContent: contentDivHeight > constants.DISPLAY_AMOUNT_HEIGHT_MAP[collapsedDisplayAmount]
      });
    }
  }, {
    key: "_isTextContent",
    value: function _isTextContent() {
      var children = this.props.children;
      return lodashIsString(children);
    }
  }, {
    key: "_getClassNames",
    value: function _getClassNames() {
      var collapsedDisplayAmount = this.props.collapsedDisplayAmount;
      var _this$state = this.state,
          isExpanded = _this$state.isExpanded,
          shouldTruncateContent = _this$state.shouldTruncateContent;

      var isTextContent = this._isTextContent();

      if (shouldTruncateContent) {
        var _classNames;

        return classNames(BASE_CSS_CLASSNAME, "".concat(BASE_CSS_CLASSNAME, "--").concat(collapsedDisplayAmount), (_classNames = {}, _defineProperty(_classNames, "".concat(BASE_CSS_CLASSNAME, "--collapsed"), !isExpanded), _defineProperty(_classNames, "".concat(BASE_CSS_CLASSNAME, "--fade"), !isTextContent), _defineProperty(_classNames, "".concat(BASE_CSS_CLASSNAME, "--truncate"), isTextContent), _classNames));
      }

      return BASE_CSS_CLASSNAME;
    }
  }, {
    key: "_handleClick",
    value: function _handleClick() {
      var _this2 = this;

      var onToggleExpanded = this.props.onToggleExpanded;
      this.setState(function (_ref) {
        var prevIsExpanded = _ref.isExpanded;
        return {
          isExpanded: !prevIsExpanded
        };
      }, function () {
        if (onToggleExpanded) {
          onToggleExpanded(_this2.state.isExpanded);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collapsedLinkText = _this$props.collapsedLinkText,
          expandedLinkText = _this$props.expandedLinkText,
          children = _this$props.children,
          toggleLocation = _this$props.toggleLocation;
      var _this$state2 = this.state,
          isExpanded = _this$state2.isExpanded,
          shouldTruncateContent = _this$state2.shouldTruncateContent;

      var readMoreClassNames = this._getClassNames();

      var component = null;
      var toggleButton = shouldTruncateContent ? React.createElement(Button, {
        style: "anchor",
        onClick: this._handleClick.bind(this),
        "data-spec": "read-more-toggle",
        __containerClassName: "eds-read-more--btn"
      }, isExpanded ? expandedLinkText : collapsedLinkText) : null;
      var readMoreContent = React.createElement("div", {
        className: "eds-read-more__content",
        ref: this._setContentDivRef
      }, children);

      switch (toggleLocation) {
        case constants.TOGGLE_LOCATION_BOTTOM:
          component = React.createElement("div", {
            className: readMoreClassNames
          }, readMoreContent, toggleButton);
          break;
        // Deliberately fall through to default toggle location (top)

        case constants.TOGGLE_LOCATION_TOP:
        default:
          component = React.createElement("div", {
            className: readMoreClassNames
          }, toggleButton, readMoreContent);
      }

      return component;
    }
  }]);

  return ReadMore;
}(React.PureComponent);

_defineProperty(ReadMore, "propTypes", {
  /**
  * The content to be displayed or hidden
  **/
  children: PropTypes.node.isRequired,

  /**
  * The display text of the link when collapsed
  **/
  collapsedLinkText: PropTypes.node,

  /**
  * The display text of the link when expanded
  **/
  expandedLinkText: PropTypes.node,

  /**
  * The amount of the content to display when in collapsed state.
  **/
  collapsedDisplayAmount: PropTypes.oneOf(constants.DISPLAY_AMOUNT_TYPES),

  /**
  * Default state for if initial state should be expanded.
  **/
  defaultIsExpanded: PropTypes.bool,

  /**
  * Callback that is called when the toggle occurs passing along the isExpanded state (bool)
  **/
  onToggleExpanded: PropTypes.func,

  /**
  * Option to set location of the collapse/expand toggle
  **/
  toggleLocation: PropTypes.oneOf(constants.TOGGLE_LOCATION_TYPES)
});

_defineProperty(ReadMore, "defaultProps", {
  collapsedLinkText: DEFAULT_COLLAPSED_LINK_TEXT,
  expandedLinkText: DEFAULT_EXPANDED_LINK_TEXT,
  collapsedDisplayAmount: constants.DISPLAY_AMOUNT_NONE,
  defaultIsExpanded: false,
  toggleLocation: constants.TOGGLE_LOCATION_TOP
});

export { ReadMore as default };